import { Component, OnInit } from "@angular/core";
import { ModelService } from "../../../Services/model.service";
import { Backup } from "../../../Model/System/Backup";
import { RestoreBackup } from "../../../Model/Dto/RestoreBackup";
import { Message } from "../../../Model/System/Message";
import { TranslateService } from '@ngx-translate/core';
import { confirm } from "devextreme/ui/dialog";
import { escape } from 'lodash';

@Component({
    selector: "backup",
    templateUrl: "backup.component.html",
    standalone: false
})
export class BackUpComponent implements OnInit {

  constructor(private modelService: ModelService, public translate: TranslateService) { }

  ngOnInit(): void {
    this.getBackUps();
  }

  public backUps: Backup[] = [];

  getBackUps() {
    this.modelService.backupService.getBackups(this.modelService.loginService.currentUser.customerId).subscribe(
      (backups: Backup[]) => {
        this.backUps = backups;
      }
    );
  }

  onGridToolbarPreparing(e) {



    e.toolbarOptions.items.unshift({
      location: 'before',
      locateInMenu: 'auto',
      template: 'refreshButtonTemplate'
    });

   

  }



  async restoreBackUp(backup: Backup) {
    const group = backup.pimGroup || this.translate.instant("unbekannt");
    const message = `${this.translate.instant("Katalog wiederherstellen")}?<br><br>`
      + `${this.translate.instant("Katalogname")}: <b>${escape(backup.catalogName)}</b><br>`
      + `${this.translate.instant("Gruppe")}: <b>${escape(group)}</b>`;
    if (!await confirm(message, this.translate.instant("Katalog wiederherstellen")))
      return;

    var restoreBackup = new RestoreBackup();
    restoreBackup.backupId = backup.id;
    restoreBackup.customerId = this.modelService.loginService.currentUser.customerId;
    restoreBackup.restoreMedia = true;
    this.modelService.backupService.restoreBackup(restoreBackup);
    this.translate.get("Das Backup wird per Job bereitgestellt").subscribe((text: string) => {
      this.modelService.systemService.notify(new Message(text));
    });
   
  }

  downloadMedia(id:string) {
    this.translate.get("Die Medien werden per Job bereitgestellt").subscribe((text: string) => {
      this.modelService.systemService.notify(new Message(text));
    });
    this.modelService.backupService.getMediaJob(id, this.modelService.loginService.currentUser.customerId);
  }


  deleteBackUp(event) {
    this.modelService.backupService.deleteBackup(event.data.id);
   
  }
}
